import type { ComponentProps } from 'react';

type Props = { size?: number } & ComponentProps<'svg'>;

export const OperationTaskIcon = ({ ...rest }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...rest}
    >
      <mask
        id="mask0_1576_26"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1576_26)">
        <path
          d="M2.75849 0.964169C2.8443 0.8655 2.95773 0.793149 3.0858 0.75839C3.25683 0.712138 3.44001 0.736608 3.59334 0.825371L14.9934 7.4248C15.1987 7.5437 15.3255 7.76271 15.3255 8.00002C15.3255 8.23732 15.1987 8.45634 14.9934 8.57523L5.86105 13.8613L5.85898 13.8633L5.85691 13.864L3.59334 15.1747C3.44001 15.2634 3.25683 15.2879 3.0858 15.2416C2.91503 15.1953 2.76943 15.0826 2.68184 14.9288C1.47925 12.8177 0.847778 10.4297 0.847778 8.00002C0.847778 5.57036 1.47925 3.18237 2.68184 1.0712L2.75849 0.964169ZM5.78164 3.62963C5.15363 5.00455 4.84597 6.46351 4.84597 8.00002C4.84597 9.52793 5.18301 10.9687 5.82308 12.3469L13.3313 8.00002L5.78164 3.62963ZM3.52222 2.32176C2.63975 4.08151 2.17775 6.02525 2.17775 8.00002C2.17775 9.97479 2.63975 11.9185 3.52222 13.6783L4.66781 13.0161C3.91923 11.4427 3.516 9.77594 3.516 8.00002C3.516 6.23348 3.88199 4.54689 4.62707 2.96119L3.52222 2.32176Z"
          fill="#1F1F22"
        />
      </g>
    </svg>
  );
};
